var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"doughnut-container"},[_c('div',[_c('canvas',{attrs:{"id":_vm.chartName}}),_c('div',{staticStyle:{"margin-top":"20px"},attrs:{"id":_vm.legendName}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }